import React from 'react'
import './styles/pattern.css'
const PatternDesign = ({page="home"}) => {
  return (
    <div className="wrapper-absolute">
   {page=="home" && <>
    <div className="spot-gradient"></div>
    <div className="spot-gradient-2"></div>
      <div className="left-corner-gradient">
      </div>
    </>}
      <div style={{
        left: page=="about" && "-33%",
        top: page=="about" && "-60%",
        transform: page=="about" && "rotate(225deg)"
      }} className="right-bottom-corner-gradient">
      </div>
      <div 
      style={{
        left: page=="about" && "-25%",
        top: page=="about" && "-60%",
        transform: page=="about" && "rotate(225deg)"
      }}
      className="right-bottom-corner-gradient right-bottom-corner-gradient-2">
      </div>
    </div>
  )
}

export default PatternDesign